import { makeAutoObservable } from 'mobx'
import type { IResponseTollFreeNumber } from 'entities/Compliance'

export class TollFreeProfileNumber {
  private _id: IResponseTollFreeNumber['id'] = 0
  private _verified_status: IResponseTollFreeNumber['verified_status'] | null = null
  private _formatted_number: IResponseTollFreeNumber['formatted_number'] | null = null
  private _number: IResponseTollFreeNumber['number'] | null = null
  private _national_number: IResponseTollFreeNumber['national_number'] | null = null
  private _is_aircall: IResponseTollFreeNumber['is_aircall'] | null = null
  private updated_at = ''
  private _numberableName: string | null = null
  private _tollFreeVerificationErrors:
    | IResponseTollFreeNumber['toll_free_verification_errors']
    | null = null
  private _individual_toll_free_profile:
    | IResponseTollFreeNumber['individual_toll_free_profile']
    | null = null

  constructor(response: IResponseTollFreeNumber) {
    makeAutoObservable(this)

    this.syncData(response)
  }

  syncData = (response: IResponseTollFreeNumber) => {
    this._id = response.id
    this._verified_status = response.verified_status
    this._formatted_number = response.formatted_number
    this._numberableName = response.numberable?.name || ''
    this._number = response.number || ''
    this._national_number = response.national_number || ''
    this._is_aircall = response.is_aircall
    this._tollFreeVerificationErrors = response.toll_free_verification_errors || null
    this._individual_toll_free_profile = response.individual_toll_free_profile || null
    this.updated_at = response.numberable?.updated_at || ''
  }

  get id() {
    return this._id
  }

  get status() {
    return this._verified_status || ''
  }

  get formattedNumber() {
    return this._formatted_number
  }

  get numberableName() {
    return this._numberableName
  }

  get verificationErrorReason() {
    return this._tollFreeVerificationErrors?.[0]?.rejection_reason || null
  }

  get number() {
    return this._number
  }

  get nationalNumber() {
    return this._national_number
  }

  get isAircall() {
    return this._is_aircall
  }

  get updatedAt() {
    return this.updated_at
  }

  get isStatusInProgress() {
    return this._verified_status === 'Unverified'
  }

  get isStatusInCarrierReview() {
    return this._verified_status === 'Under Review'
  }

  get isStatusVerified() {
    return this._verified_status === 'Verified'
  }

  get isStatusPendingReview() {
    return this._verified_status === 'Internal Review'
  }

  get isStatusRejected() {
    return this._verified_status === 'Denied'
  }

  get isStatusBlocked() {
    return this._verified_status === 'Blocked'
  }

  get individualTollFreeProfile() {
    return this._individual_toll_free_profile
  }
}
